import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useHistory } from "react-router-dom";

// Cabecera común de las secciones: título y botón para añadir un elemento.
// Con addPath abre el formulario común con el tipo ya seleccionado (/nuevo/<tipo>);
// con onAdd lo gestiona la propia sección (p. ej. un modal). Sin addLabel no hay botón.
type SectionHeaderProps = {
  title: string;
  addLabel?: string;
  addPath?: string;
  onAdd?: () => void;
};

export default function SectionHeader(props: SectionHeaderProps) {
  const { title, addLabel, addPath, onAdd } = props;
  const history = useHistory();
  const handleAdd = () => (onAdd ? onAdd() : addPath && history.push(addPath));
  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
      <h4 className="main-title m-0">{title}</h4>
      {addLabel ? (
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleAdd}>
          {addLabel}
        </Button>
      ) : null}
    </div>
  );
}
